import { render } from "./ContentSpmi.vue?vue&type=template&id=1855f55c"
import script from "./ContentSpmi.vue?vue&type=script&lang=js"
export * from "./ContentSpmi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__